import { FC, PropsWithChildren, useEffect } from 'react';
import { useFeatureFlagVariantKey } from '@posthog/react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAppSelector } from '../redux/hooks';
import { selectUser } from '../redux/reducers/userSlice';
import { NO_CONDITION_VARIANT_NAME, useAssignmentLogger } from './useAssignmentLogger';
import { useObservationLogger } from './useObservationLogger';

export const useCondition = (flagName: string): string => {
  const variant = useFeatureFlagVariantKey(flagName);

  return typeof variant === 'string' ? variant : NO_CONDITION_VARIANT_NAME;
};

let sessionLogged = false;

export const ExperimentsProvider: FC<PropsWithChildren> = ({ children }) => {
  const { user } = useAuth0();
  const userRedux = useAppSelector(selectUser);
  const { logObservations } = useObservationLogger();

  useAssignmentLogger(user?.sub);

  useEffect(() => {
    if (!userRedux?.id || sessionLogged) return;
    sessionLogged = true;
    logObservations('engagement_metrics', [{ subject: 'platform', type: 'app_load' }]);
  }, [userRedux?.id, logObservations]);

  return <>{children}</>;
};

export default ExperimentsProvider;
